import { render, staticRenderFns } from "./TargetForm.vue?vue&type=template&id=231120bc&scoped=true&"
import script from "./TargetForm.vue?vue&type=script&lang=js&"
export * from "./TargetForm.vue?vue&type=script&lang=js&"
import style0 from "./TargetForm.vue?vue&type=style&index=0&id=231120bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231120bc",
  null
  
)

export default component.exports